/* TRATHAM — Página de produto: galeria, zoom, variantes, compra e barra fixa (mobile). */

window.TrCart = window.TrCart || {
  /* Atualiza o carrinho lateral do Vision com as seções retornadas pela Cart API e abre a gaveta */
  refresh(sections) {
    const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
    const drawer = document.getElementById('Cart-Drawer');
    if (drawer && sections['cart-drawer']) {
      const target = drawer.querySelector('.cart-drawer') || drawer;
      const html = parse(sections['cart-drawer'], '.cart-drawer');
      if (html !== undefined) target.innerHTML = html;
    }
    const bubble = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (bubble && sections['cart-bubble']) {
      const html = parse(sections['cart-bubble'], '.thb-item-count');
      if (html !== undefined) bubble.innerHTML = html;
    }
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = window.theme?.routes?.cart_url || '/cart';
  },
  money(cents, format) {
    const [int, dec] = (cents / 100).toFixed(2).split('.');
    const dots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const commas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || 'R$ {{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: `${commas}.${dec}`,
      amount_no_decimals: commas,
      amount_with_comma_separator: `${dots},${dec}`,
      amount_no_decimals_with_comma_separator: dots,
    }[key] ?? `${dots},${dec}`));
  },
};

/* Diálogos simples (guia de medidas) */
document.addEventListener('click', (event) => {
  const zoomBtn = event.target.closest('[data-size-zoom]');
  if (zoomBtn) {
    const page = zoomBtn.closest('.tr-sheet__body')?.querySelector('[data-size-page]');
    const on = !page.classList.contains('is-zoomed');
    page.classList.toggle('is-zoomed', on);
    zoomBtn.setAttribute('aria-pressed', String(on));
    return;
  }
  const opener = event.target.closest('[data-dialog-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.dialogOpen);
    if (dialog?.showModal) { dialog.showModal(); dialog.querySelector('[data-dialog-close]')?.focus(); }
    return;
  }
  const closer = event.target.closest('[data-dialog-close]');
  if (closer) closer.closest('dialog')?.close();
  if (event.target.tagName === 'DIALOG' && event.target.classList.contains('tr-sheet')) event.target.close();
});

/* Galeria + zoom */
if (!customElements.get('tr-gallery')) {
  customElements.define('tr-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.current = this.querySelector('[data-gallery-current]');
      this.zoom = this.querySelector('[data-zoom]');
      this.items = [...this.querySelectorAll('[data-gallery-item]')];
      if (this.current && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) this.setCurrent(Number(entry.target.dataset.index));
          });
        }, { root: null, threshold: [0.6] });
        this.items.forEach((item) => io.observe(item));
      }
      this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
      this.index = 0;
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.galleryDot))));
      this.arrows = [...this.querySelectorAll('[data-gallery-step]')];
      this.arrows.forEach((btn) => btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.galleryStep))));
      this.querySelectorAll('[data-zoom-open]').forEach((btn) => btn.addEventListener('click', () => this.openZoom(Number(btn.dataset.zoomOpen))));
      this.zoom?.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.zoom.close());
      this.zoom?.addEventListener('close', () => this.unlockPage());
      document.addEventListener('product:variant-change', (e) => {
        const values = (e.detail?.selectedOptions || []).map((o) => o.value).filter(Boolean);
        if (values.length) this.dataset.variantTitle = values.join(' / ');
      });
    }
    goTo(index) {
      const item = this.items[index];
      if (item && this.track) this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
    setCurrent(index) {
      this.index = index;
      if (this.current) this.current.textContent = index + 1;
      this.arrows?.forEach((btn) => {
        const step = Number(btn.dataset.galleryStep);
        btn.hidden = step < 0 ? index === 0 : index === this.items.length - 1;
      });
      this.dots?.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }
    /* TRATHAM: trava a página por trás do zoom (no iPhone, overflow:hidden no body não basta e a página pulava ao fechar) — 2026-10-27 */
    lockPage() {
      this.scrollY = window.scrollY;
      document.body.classList.add('tr-zoom-open');
      document.body.style.top = `-${this.scrollY}px`;
    }
    unlockPage() {
      if (!document.body.classList.contains('tr-zoom-open')) return;
      document.body.classList.remove('tr-zoom-open');
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY || 0);
    }
    /* TRATHAM: zoom do Vision (PhotoSwipe) — mesma lógica do product-slider em product.js — 2026-10-30 */
    openPhotoSwipe(mediaIndex) {
      const pswpEl = document.querySelector('.pswp');
      if (!pswpEl || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return false;
      const buttons = [...this.querySelectorAll('[data-pswp-src]')];
      const start = buttons.findIndex((btn) => Number(btn.dataset.zoomOpen) === mediaIndex);
      if (start < 0) return false;
      const items = buttons.map((btn) => ({
        src: btn.dataset.pswpSrc,
        msrc: btn.dataset.pswpMsrc,
        w: Number(btn.dataset.pswpW),
        h: Number(btn.dataset.pswpH),
        thumbSrc: btn.dataset.pswpMsrc,
      }));

      const info = pswpEl.querySelector('.pswp__product-info');
      if (info) {
        info.querySelector('.pswp__product-title').textContent = this.dataset.productTitle || '';
        info.querySelector('.pswp__variant-title').textContent = this.dataset.variantTitle || '';
      }
      const thumbs = pswpEl.querySelector('.pswp__thumbs-inner');
      if (thumbs) {
        thumbs.innerHTML = '';
        thumbs.parentElement.style.display = items.length > 1 ? '' : 'none';
        if (items.length > 1) {
          items.forEach((item, i) => {
            const thumb = document.createElement('div');
            thumb.className = 'pswp__thumb';
            thumb.dataset.index = i;
            const img = document.createElement('img');
            img.src = item.thumbSrc;
            img.alt = '';
            img.loading = 'lazy';
            thumb.appendChild(img);
            thumbs.appendChild(thumb);
          });
        }
      }
      const bottomBar = pswpEl.querySelector('.pswp__bottom-bar');
      if (bottomBar && !bottomBar.dataset.trBound) {
        bottomBar.dataset.trBound = 'true';
        ['mousedown', 'touchstart', 'pointerdown'].forEach((name) => bottomBar.addEventListener(name, (evt) => evt.stopPropagation()));
      }
      const syncThumbs = (i) => {
        thumbs?.querySelectorAll('.pswp__thumb').forEach((thumb, n) => thumb.classList.toggle('is-active', n === i));
        thumbs?.querySelector('.pswp__thumb.is-active')?.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      };

      const pswp = new PhotoSwipe(pswpEl, PhotoSwipeUI_Default, items, {
        index: start,
        maxSpreadZoom: 2,
        loop: true,
        allowPanToNext: true,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: (i) => {
          const rect = buttons[i].getBoundingClientRect();
          return { x: rect.left, y: rect.top + window.pageYOffset, w: rect.width };
        },
      });
      document.body.classList.add('open-lightbox');
      pswp.listen('parseVerticalMargin', (item) => { item.vGap = { top: 50, bottom: 140 }; });
      pswp.listen('beforeChange', () => {
        const i = pswp.getCurrentIndex();
        syncThumbs(i);
        const mediaI = Number(buttons[i].dataset.zoomOpen);
        const item = this.items[mediaI];
        if (item && this.track) this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft });
      });
      const onThumb = (evt) => {
        evt.stopPropagation();
        const thumb = evt.target.closest('.pswp__thumb');
        if (thumb) pswp.goTo(Number(thumb.dataset.index));
      };
      thumbs?.addEventListener('click', onThumb);
      pswp.listen('destroy', () => {
        document.body.classList.remove('open-lightbox');
        thumbs?.removeEventListener('click', onThumb);
        if (thumbs) thumbs.innerHTML = '';
      });
      pswp.init();
      syncThumbs(start);
      return true;
    }
    openZoom(index) {
      if (this.openPhotoSwipe(index)) return;
      if (!this.zoom?.showModal || this.zoom.open) return;
      this.zoom.querySelectorAll('img[data-zoom-src]').forEach((img) => {
        if (img.getAttribute('src')) return;
        if (img.dataset.zoomSrcset) img.srcset = img.dataset.zoomSrcset;
        img.src = img.dataset.zoomSrc;
      });
      this.lockPage();
      this.zoom.showModal();
      const target = this.zoom.querySelector(`[data-zoom-index="${index}"]`);
      this.zoom.scrollTop = target ? target.offsetTop : 0;
      this.zoom.querySelector('[data-zoom-close]')?.focus({ preventScroll: true });
    }
  });
}

/* Formulário de produto */
if (!customElements.get('tr-product-form')) {
  customElements.define('tr-product-form', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-input]');
      this.addBtn = this.querySelector('[data-add]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.status = this.querySelector('[data-status]');
      this.stock = this.querySelector('[data-stock]');
      this.fieldsets = [...this.querySelectorAll('[data-option-index]')];
      this.section = this.closest('[data-section]');
      this.priceEls = this.section ? [...this.section.querySelectorAll('[data-price], [data-bar-price]')] : [];
      this.format = this.dataset.moneyFormat;
      this.preorder = this.dataset.preorder === 'true';

      /* TRATHAM: "Avise-me quando voltar ao estoque" → WhatsApp oficial (tamanho ou peça esgotada) — 2026-10-21 */
      this.notify = this.section?.querySelector('[data-restock]');
      this.restockLink = this.notify?.querySelector('[data-restock-link]');
      this.restockText = this.notify?.querySelector('[data-restock-text]');
      this.allSoldOut = !this.variants.some((v) => v.available);

      /* TRATHAM: pré-lançamento some depois do último dia (horário de Brasília), mesmo com a página em cache — 2026-10-27 */
      this.section?.querySelectorAll('[data-prelaunch][data-ends]').forEach((el) => {
        const fim = new Date(`${el.dataset.ends}T23:59:59-03:00`);
        if (!Number.isNaN(fim.getTime()) && Date.now() > fim.getTime()) { el.dataset.expired = 'true'; el.hidden = true; }
      });

      this.fieldsets.forEach((fs) => fs.addEventListener('change', () => this.onChange()));
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.add(); });
      this.setupBar();
      this.update(false);
    }

    /* Mensagem do WhatsApp: peça, cor e tamanho escolhidos (a cor também pode ser opção da variante) */
    updateRestock(values) {
      const a = this.restockLink;
      if (!a) return;
      let cor = a.dataset.cor || '';
      const outros = [];
      this.fieldsets.forEach((fs, i) => {
        const nome = (fs.querySelector('legend')?.childNodes[0]?.textContent || '').trim().replace(/:$/, '').toLowerCase();
        if (!values[i]) return;
        if (['cor', 'color', 'colour'].includes(nome)) cor = values[i]; else outros.push(values[i]);
      });
      let detalhes = '';
      if (cor) detalhes += `, ${a.dataset.wordColor} ${cor}`;
      if (outros.length) detalhes += `, ${a.dataset.wordSize} ${outros.join(' / ')}`;
      const msg = a.dataset.template.replace('__PRODUTO__', a.dataset.nome).replace('__DETALHES__', detalhes);
      a.href = `https://wa.me/${a.dataset.wa}?text=${encodeURIComponent(msg)}`;
      if (this.restockText) this.restockText.textContent = (this.allSoldOut && !outros.length) ? this.restockText.dataset.allText : this.restockText.dataset.sizeText;
    }

    selectedValues() {
      return this.fieldsets.map((fs) => fs.querySelector('[data-option-input]:checked')?.value ?? null);
    }

    findVariant(values) {
      if (!this.fieldsets.length) return this.variants[0];
      if (values.some((v) => v === null)) return null;
      return this.variants.find((v) => v.options.every((opt, i) => opt === values[i])) || null;
    }

    onChange() {
      this.update(true);
    }

    update(fromUser) {
      const values = this.selectedValues();
      const variant = this.findVariant(values);
      this.variant = variant;

      // Disponibilidade por valor, considerando as demais escolhas
      this.fieldsets.forEach((fs, index) => {
        const label = fs.querySelector('[data-option-value]');
        if (label && values[index]) label.textContent = values[index];
        fs.querySelectorAll('[data-option-input]').forEach((input) => {
          // Existe variante disponível com este valor + as outras escolhas já feitas?
          const possible = this.variants.some((v) => v.available && v.options.every((opt, i) => (
            i === index ? opt === input.value : (values[i] === null || opt === values[i])
          )));
          input.nextElementSibling?.classList.toggle('is-unavailable', !possible);
        });
      });

      this.idInput.value = variant ? variant.id : '';
      const ready = !!variant && variant.available;
      this.addBtn.setAttribute('aria-disabled', String(!ready));
      let label = this.strings.add;
      if (!variant) label = values.some((v) => v === null) ? this.strings.choose : this.strings.unavailable;
      else if (!variant.available) label = this.strings.soldout;
      else if (this.preorder) label = this.strings.preorder;
      this.addLabel.textContent = label;
      if (this.notify) {
        const esgotado = this.allSoldOut || (!!variant && !variant.available);
        this.notify.hidden = !esgotado;
        this.addBtn.hidden = esgotado;
        if (esgotado) this.updateRestock(values);
      }
      if (this.barLabel) {
        // Rótulo curto na barra: o tamanho é escolhido nos próprios chips
        const semEstoque = this.allSoldOut || (variant && !variant.available);
        this.barLabel.textContent = semEstoque ? (this.notify ? this.strings.notify_short : this.strings.soldout) : (this.preorder ? this.strings.preorder_short : this.strings.add_short);
      }

      if (variant) {
        const html = variant.compare > variant.price
          ? `<s class="tr-price__compare">${TrCart.money(variant.compare, this.format)}</s> <span class="tr-price__current tr-price__current--sale">${TrCart.money(variant.price, this.format)}</span>`
          : `<span class="tr-price__current">${TrCart.money(variant.price, this.format)}</span>`;
        this.priceEls.forEach((el) => { el.innerHTML = html; });
        /* TRATHAM: valor da parcela acompanha a variante — 2026-10-26 */
        this.section?.querySelectorAll('[data-installments]').forEach((el) => {
          const n = Number(el.dataset.installments) || 1;
          const alvo = el.querySelector('[data-installments-value]');
          if (alvo) alvo.textContent = TrCart.money(Math.floor(variant.price / n), this.format);
        });
        /* TRATHAM: selo da campanha acompanha a variante (some sem desconto real) — 2026-11-03 */
        this.section?.querySelectorAll('[data-campaign]').forEach((el) => {
          const comDesconto = variant.compare > variant.price;
          el.hidden = !comDesconto;
          const pct = el.querySelector('[data-campaign-pct]');
          if (pct && comDesconto) pct.textContent = `−${Math.round((variant.compare - variant.price) * 100 / variant.compare)}%`;
        });
        /* TRATHAM: pré-lançamento acompanha a variante (some sem desconto real) — 2026-10-27 */
        this.section?.querySelectorAll('[data-prelaunch]').forEach((el) => {
          const comDesconto = variant.compare > variant.price;
          el.hidden = !comDesconto || el.dataset.expired === 'true';
          if (!comDesconto) return;
          const pct = Number(el.dataset.couponPercent) || 0;
          const economia = el.querySelector('[data-prelaunch-saving]');
          const final = el.querySelector('[data-prelaunch-final]');
          if (economia) economia.textContent = TrCart.money(variant.compare - variant.price, this.format).replace(/,00$/, '');
          if (final) final.textContent = TrCart.money(Math.floor(variant.price * (100 - pct) / 100), this.format);
        });
      }

      this.syncBar();

      if (this.stock) {
        const low = variant && variant.available && variant.low;
        this.stock.hidden = !low;
        this.stock.textContent = low ? this.strings.low : '';
      }

      if (fromUser) {
        if (variant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        this.status.textContent = '';
        document.dispatchEvent(new CustomEvent('product:variant-change', {
          detail: {
            productId: this.dataset.productId,
            productTitle: this.dataset.productTitle,
            productHandle: this.dataset.productHandle,
            selectedOptions: this.fieldsets.map((fs, i) => ({ name: fs.querySelector('legend')?.childNodes[0]?.textContent.trim().replace(/:$/, ''), value: values[i] })).filter((o) => o.value),
            variant: variant ? { id: variant.id, available: variant.available, price: variant.price } : null,
          },
        }));
      }
    }

    async add(source) {
      if (this.notify && (this.allSoldOut || (this.variant && !this.variant.available))) {
        if (source === 'bar' && this.restockLink) { window.open(this.restockLink.href, '_blank', 'noopener'); return; }
        this.notify.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.restockLink?.focus({ preventScroll: true });
        return;
      }
      if (!this.variant && source === 'bar' && this.barSizes) {
        this.barSizes.classList.add('is-required');
        this.barSizes.querySelector('.tr-pdp__chip:not(.is-unavailable)')?.focus();
        setTimeout(() => this.barSizes.classList.remove('is-required'), 1600);
        return;
      }
      if (!this.variant) {
        this.status.textContent = this.strings.choose;
        const sizeFs = this.fieldsets.find((fs) => fs.classList.contains('tr-pdp__option--size')) || this.fieldsets[0];
        sizeFs?.classList.add('is-required');
        sizeFs?.querySelector('[data-option-input]')?.focus({ preventScroll: true });
        sizeFs?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => sizeFs?.classList.remove('is-required'), 1600);
        return;
      }
      if (!this.variant.available) return;
      this.addBtn.setAttribute('aria-busy', 'true');
      this.barAdd?.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${window.theme?.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: this.variant.id, quantity: 1 }],
            sections: ['cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || '');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: { variant_id: this.variant.id }, quantity: 1, context: 'product' } }));
        this.status.textContent = this.strings.added;
        TrCart.refresh(data.sections || {});
      } catch (error) {
        this.status.textContent = error.message || this.strings.error;
        document.dispatchEvent(new CustomEvent('product:variant-error', { detail: { message: error.message } }));
      } finally {
        this.addBtn.removeAttribute('aria-busy');
        this.barAdd?.removeAttribute('aria-busy');
      }
    }

    /* Barra fixa (mobile): aparece quando o botão principal sai da tela */
    setupBar() {
      this.bar = this.section?.querySelector('[data-buy-bar]');
      if (!this.bar) return;
      this.barAdd = this.bar.querySelector('[data-bar-add]');
      this.barLabel = this.bar.querySelector('[data-bar-label]');
      this.barSizes = this.bar.querySelector('[data-bar-sizes]');
      const sizeFs = this.fieldsets.find((fs) => fs.classList.contains('tr-pdp__option--size'));
      if (this.barSizes && sizeFs) {
        sizeFs.querySelectorAll('[data-option-input]').forEach((input) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'tr-pdp__chip';
          chip.textContent = input.value;
          chip.dataset.value = input.value;
          chip.tabIndex = -1;
          chip.addEventListener('click', () => { input.checked = true; this.onChange(); });
          this.barSizes.appendChild(chip);
        });
        this.sizeFs = sizeFs;
      }
      this.barAdd?.addEventListener('click', () => this.add('bar'));
      const anchor = this.querySelector('[data-buy-anchor]');
      if (anchor) {
        // Posição calculada a cada rolagem (robusto a saltos instantâneos, ex.: voltar ao topo)
        let ticking = false;
        const check = () => {
          ticking = false;
          // TRATHAM: recolhe quando o rodapé entra na tela, para não cobrir a navegação final — 2026-10-20
          const rodape = document.querySelector('.tr-footer-section, .tr-footer, footer');
          const fimDaPagina = rodape && rodape.getBoundingClientRect().top < window.innerHeight - 24;
          const show = anchor.getBoundingClientRect().bottom < 0 && !fimDaPagina;
          if (show === this.bar.classList.contains('is-visible')) return;
          this.bar.classList.toggle('is-visible', show);
          document.body.classList.toggle('tr-bar-visible', show);
          this.bar.setAttribute('aria-hidden', String(!show));
          this.barAdd.tabIndex = show ? 0 : -1;
          this.bar.querySelectorAll('.tr-pdp__chip').forEach((c) => { c.tabIndex = show ? 0 : -1; });
        };
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', check);
        check();
      }
      this.syncBar();
    }

    syncBar() {
      if (!this.barSizes || !this.sizeFs) return;
      const checked = this.sizeFs.querySelector('[data-option-input]:checked')?.value;
      this.barSizes.querySelectorAll('.tr-pdp__chip').forEach((chip) => {
        const input = [...this.sizeFs.querySelectorAll('[data-option-input]')].find((i) => i.value === chip.dataset.value);
        chip.classList.toggle('is-selected', chip.dataset.value === checked);
        chip.classList.toggle('is-unavailable', !!input?.nextElementSibling?.classList.contains('is-unavailable'));
        chip.setAttribute('aria-pressed', String(chip.dataset.value === checked));
      });
    }
  });
}

